function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import React, { memo, useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { Portal } from '../../Portal';
import CloseIcon from '@magento/venia-ui/venia-static/icons/closeicon.svg';
import usePlacesService from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import classes from './storeCheckoutLocatorModal.css';
import PlacesWithStandaloneSearchBox from './googleMapSearchBox';
import GoogleMapContainer from './googleMapContainer';
import StoreList from './storeList';
import StoreDetails from './storeDetails';
import useMediaQuery from 'react-use-media-query-hook';
import { MEDIA_MAX_TABLET } from '../../../helpers/mediaQuery';
import { useIntl, FormattedMessage } from 'react-intl';
import { ChevronDown as ArrowDown, ChevronUp as ArrowUp } from 'react-feather';
import Icon from '../../../components/Icon';
import useCheckoutStoreLocatorModal from './useCheckoutStoreLocatorModal';
import useStoreList from "./useStoreList";
import ReactToggle from "../../ReactToggle";
import { mapEnvironment } from "./googleMapHoc";
import { sendGTMEvent } from "../../../util/initGTM";
import BBLink from "../../BBLink";
var distance = ['25 km', '50 km', '100 km', '250 km', '500 km'];
var StoreCheckoutLocatorModal = props => {
  var {
    productsInCart,
    setOpenStoreModal,
    isDetailedStock,
    infiniteScroll,
    forceAllStores,
    fromPage,
    isPage
  } = props;
  var {
    formatMessage
  } = useIntl();
  var [openScheduleIndex, setOpenScheduleIndex] = useState(null);
  var [selectedStore, setSelectedStore] = useState(null);
  var [searchedLocation, setSearchedLocation] = useState(null);
  var [stores, setStores] = useState([]);
  var [distanceKMInput, setDistanceKMInput] = useState('25 km');
  var [openInfoWindow, setOpenInfoWindow] = useState(null);
  var [open, setOpen] = useState(false);
  var [onlyInStock, setOnlyInStock] = useState(!forceAllStores);
  var [searchString, setSearchString] = useState("");
  var [currentPage, setCurrentPage] = useState(0);
  var [currentGroupPage, setCurrentGroupPage] = useState(0);
  var [triggerSearchState, setTriggerSearchState] = useState({
    distanceKMInput,
    searchedLocation
  });
  var node = useRef();
  var iconSrc = open ? ArrowUp : ArrowDown;
  var titleIcon = /*#__PURE__*/React.createElement(Icon, {
    src: iconSrc,
    size: 24
  });
  var isMaxTablet = useMediaQuery(MEDIA_MAX_TABLET);
  var inputLocationRef = useRef(null);
  var {
    placesService,
    placePredictions,
    getPlacePredictions: getPlacePredictionsGoogle
  } = usePlacesService({
    apiKey: process.env.GOOGLE_MAPS_API_KEY,
    //impossible to get geo results, API is different
    options: {
      types: ['(regions)'],
      //fields: not passing to use default values
      componentRestrictions: {
        country: 'ca'
      }
    },
    libraries: ['places']
  });
  var getPlacePredictions = useCallback(() => {
    if (searchString) {
      getPlacePredictionsGoogle({
        input: searchString
      });
    }
  }, [searchString]);
  useEffect(() => {
    if (searchString) {
      getPlacePredictions();
    }
  }, [searchString]);
  var {
    stores: dataStores
  } = useCheckoutStoreLocatorModal({
    triggerSearchState,
    forceAllStores
  });
  var ref = useRef();
  useEffect(() => {
    if (ref && ref.current && !isPage) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [ref, ref.current]);
  var STATIC_STRINGS = useMemo(() => {
    return {
      selectYourStore: formatMessage({
        defaultMessage: 'Select Your Store',
        id: 'storeSchedule.selectYourStore'
      }),
      location: formatMessage({
        defaultMessage: 'Location',
        id: 'storeSchedule.location'
      }),
      distance: 'Distance',
      findAStore: formatMessage({
        defaultMessage: 'Find a Store',
        id: 'storeSchedule.findAStore'
      }),
      listOfStores: "".concat(formatMessage({
        defaultMessage: 'store(s)',
        id: 'Stores'
      }), " ").concat(formatMessage({
        defaultMessage: 'near',
        id: 'storeSchedule.near'
      }), " ").concat(inputLocationRef && inputLocationRef.current ? inputLocationRef.current.value : '', " ").concat(formatMessage({
        defaultMessage: 'within',
        id: 'storeSchedule.within'
      }), " ").concat(triggerSearchState.distanceKMInput ? "".concat(triggerSearchState.distanceKMInput) : ''),
      listOfStoresDefault: "".concat(formatMessage({
        defaultMessage: 'List of stores',
        id: 'storeSchedule.listOfStoresDefault'
      }), " - 0 ").concat(formatMessage({
        defaultMessage: 'stores',
        id: 'stores'
      })),
      reset: formatMessage({
        defaultMessage: 'Reset',
        id: 'storeSchedule.reset'
      }),
      seeMap: formatMessage({
        defaultMessage: 'See Map',
        id: 'storeSchedule.seeMap'
      }),
      closeMap: formatMessage({
        defaultMessage: 'Close Map',
        id: 'storeSchedule.closeMap'
      }),
      stockToggleLabel: formatMessage({
        defaultMessage: 'In Stock Only',
        id: 'storeSchedule.inStockOnly'
      })
    };
  }, [stores, triggerSearchState]);
  useEffect(() => {
    document.addEventListener('mouseup', closeMenu);
    return () => {
      document.removeEventListener('mouseup', closeMenu);
    };
  }, []);
  var closeMenu = e => {
    if (node && !node.current.contains(e.target)) {
      setOpen(false);
    }
  };
  var resetInputs = () => {
    setDistanceKMInput('25 km');
    setSearchedLocation(null);
    setOpenInfoWindow(null);
    if (dataStores) {
      setStores(dataStores);
    }
    setCurrentGroupPage(0);
    setCurrentPage(0);
    setSearchString("");
  };
  var triggerSearch = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (e) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      e.preventDefault();
      e.stopPropagation();
      document.activeElement.blur();
      google.maps.event.trigger(inputLocationRef.current, 'keydown', {
        keyCode: 13
      });
      setCurrentGroupPage(0);
      setCurrentPage(0);

      //getPlacePredictions is in useMemo so no waste of time doing another request here
      //needed to make sure that we have latest results if user is fast enough to click
      Promise.resolve().then( /*#__PURE__*/_asyncToGenerator(function* () {
        return yield getPlacePredictions();
      })).then( /*#__PURE__*/_asyncToGenerator(function* () {
        var place = placePredictions && placePredictions[index];
        if (!place || !place.place_id) {
          //will search with current geo location
          setTriggerSearchState({
            distanceKMInput,
            searchedLocation: null
          });
          return;
        }

        // fetch place details for the first element in placePredictions array
        yield placesService.getDetails({
          placeId: place.place_id
        }, placeDetails => {
          var {
            geometry
          } = placeDetails;
          var searchObj = {
            name: place.description,
            lat: geometry.location.lat(),
            lng: geometry.location.lng()
          };
          setTriggerSearchState({
            distanceKMInput,
            searchedLocation: searchObj
          });
        });
        sendGTMEvent({
          event: 'store_locator'
        });
      }));
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [searchString, placePredictions, distanceKMInput, fromPage]);

  //filter only bopis enabled stores
  useEffect(() => {
    if (dataStores && !forceAllStores) {
      var filteredStores = dataStores.filter(st => (st === null || st === void 0 ? void 0 : st.is_active) === 1 && (st === null || st === void 0 ? void 0 : st.bopis_enabled) === '1');
      setStores(filteredStores);
    }
  }, [dataStores]);
  var distanceKm = useMemo(() => distance.map((item, index) => {
    return /*#__PURE__*/React.createElement("button", {
      key: index,
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
        setDistanceKMInput(item);
      },
      className: distanceKMInput === item ? classes.itemDistanceSelected : classes.itemDistance
    }, item);
  }), [distanceKMInput]);
  var {
    storesStock
  } = forceAllStores ? {
    storesStock: dataStores
  } : useStoreList({
    productsInCart,
    currentStores: stores,
    cached: false
  });
  console.log(storesStock);
  var scrollToStoresList = () => {
    var storesListElement = document.getElementById("stores-counter");
    storesListElement.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start"
    });
  };
  useEffect(() => {
    if (storesStock && storesStock.length && triggerSearchState && triggerSearchState.searchedLocation) {
      scrollToStoresList();
      var _zip = storesStock && storesStock[0] && storesStock[0].zipcode && storesStock[0].zipcode.split(' ')[0];
      switch (fromPage) {
        case 'checkout':
          {
            sendGTMEvent({
              eventCategory: 'checkout step 4.1.1 - select a store',
              eventAction: 'Select Other Store Overlay',
              eventLabel: "Other stores displayed - search by ".concat(_zip),
              storesCount: storesStock.length,
              distanceToStore: storesStock[0].distance,
              event: 'genericGAEvent'
            });
            break;
          }
      }
    }
  }, [storesStock && storesStock.length && storesStock[0] && storesStock[0].zipcode]);
  var storesByStock = useMemo(() => {
    return storesStock ? onlyInStock ? storesStock.filter(st => st.inStock === true) : storesStock : [];
  }, [storesStock, onlyInStock]);
  useEffect(() => {
    if (onlyInStock && storesStock && storesStock.length && !forceAllStores) {
      var checkOnlyInStock = storesStock.filter(st => st.inStock === true);
      if (!checkOnlyInStock || !checkOnlyInStock.length) {
        setOnlyInStock(false);
      }
    }
  }, [storesStock]);
  var paginationStores = useMemo(() => {
    //creating clone because SPLICE at the bottom will remove elements BY REFERENCE
    //i dont want to touch following logic
    var storesByStockCLONE = [...storesByStock];
    if (storesByStockCLONE) {
      var pStores = [];
      var pGroupStores = [];
      while (storesByStockCLONE.length > 0) {
        pStores.push(storesByStockCLONE.splice(0, 3));
      }
      while (pStores.length > 0) {
        pGroupStores.push(pStores.splice(0, 3));
      }
      return pGroupStores;
    }
    return [];
  }, [storesByStock]);
  var currentStores = useMemo(() => {
    if (paginationStores.length > 0) {
      return paginationStores[currentGroupPage][currentPage];
    }
    return [];
  }, [currentPage, currentGroupPage, paginationStores]);
  var storeLocatorRender = /*#__PURE__*/React.createElement("div", {
    className: isPage ? classes.pageStoreLocatorModal : "".concat(classes['openStoreLocatorModal'])
  }, !isPage && /*#__PURE__*/React.createElement("div", {
    className: classes.modalCloseBtn,
    onClick: () => {
      setOpenStoreModal(false);
      switch (fromPage) {
        case 'cart':
          {
            sendGTMEvent({
              eventCategory: 'checkout step 1 - cart',
              eventAction: 'popup in cart',
              eventLabel: "Store Locator - X",
              event: 'genericGAEvent'
            });
            break;
          }
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CloseIcon,
    height: 20,
    width: 20,
    alt: 'closeIcon'
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.header,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", null, STATIC_STRINGS.selectYourStore)), /*#__PURE__*/React.createElement("div", {
    className: classes.inputsContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.inputLabelLocation
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.label
  }, STATIC_STRINGS.location), /*#__PURE__*/React.createElement(PlacesWithStandaloneSearchBox, {
    inputLocationRef: inputLocationRef,
    placePredictions: placePredictions,
    searchString: searchString,
    setSearchString: setSearchString,
    triggerSearch: triggerSearch,
    fromPage: fromPage
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.inputLabelDistance
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.label
  }, STATIC_STRINGS.distance), /*#__PURE__*/React.createElement("div", {
    className: open ? classes.openSectionDistance : classes.sectionDistance
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.optionSelected,
    ref: node
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.inputKM,
    onClick: () => {
      setOpen(!open);
      switch (fromPage) {
        case 'checkout':
          {
            sendGTMEvent({
              eventCategory: 'checkout step 4.1.1 - select a store',
              eventAction: 'Select Other Store Overlay',
              eventLabel: 'Field: Distance',
              event: 'genericGAEvent'
            });
            break;
          }
      }
    }
  }, /*#__PURE__*/React.createElement("span", null, distanceKMInput), /*#__PURE__*/React.createElement("span", {
    className: classes.icon
  }, titleIcon))), /*#__PURE__*/React.createElement("div", {
    className: classes.options
  }, distanceKm))), /*#__PURE__*/React.createElement("button", {
    className: classes.findAStoreButton,
    onClick: /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* (e) {
        yield triggerSearch(e);
      });
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }()
  }, STATIC_STRINGS.findAStore), /*#__PURE__*/React.createElement("button", {
    className: classes.resetButton,
    onClick: () => {
      resetInputs();
    }
  }, STATIC_STRINGS.reset)), /*#__PURE__*/React.createElement("div", {
    className: classes.listOfStores,
    id: 'stores-counter'
  }, storesStock && storesStock.length ? /*#__PURE__*/React.createElement("p", {
    className: classes.listOfStoresLabel
  }, storesByStock && storesByStock.length || 0, " ", STATIC_STRINGS.listOfStores) : /*#__PURE__*/React.createElement("p", {
    className: classes.listOfStoresLabel
  }, STATIC_STRINGS.listOfStoresDefault)), !forceAllStores ? /*#__PURE__*/React.createElement("div", {
    className: classes.toggleContainer
  }, /*#__PURE__*/React.createElement(ReactToggle, {
    checked: onlyInStock,
    onChange: () => {
      //if current state is "only in stock" but next state is out of stock
      if (onlyInStock) {
        switch (fromPage) {
          case 'checkout':
            {
              sendGTMEvent({
                eventCategory: 'checkout step 4.1.1 - select a store',
                eventAction: 'Select Other Store Overlay',
                eventLabel: 'In Stock Stores Only filter removed',
                event: 'genericGAEvent'
              });
              break;
            }
        }
      }
      setOnlyInStock(!onlyInStock);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.toggleLabel
  }, STATIC_STRINGS.stockToggleLabel)) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.storesMapContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.storesContainer
  }, selectedStore ? /*#__PURE__*/React.createElement(StoreDetails, {
    selectedStore: selectedStore,
    setSelectedStore: setSelectedStore,
    setOpenScheduleIndex: setOpenScheduleIndex,
    formatMessage: formatMessage
  }) : /*#__PURE__*/React.createElement(StoreList, {
    closeModal: setOpenStoreModal,
    storesStock: infiniteScroll ? storesByStock : currentStores,
    openScheduleIndex: openScheduleIndex,
    setOpenScheduleIndex: setOpenScheduleIndex,
    setSelectedStore: setSelectedStore,
    setOpenInfoWindow: setOpenInfoWindow,
    productsInCart: productsInCart,
    setCurrentGroupPage: setCurrentGroupPage,
    setCurrentPage: setCurrentPage,
    currentPage: currentPage,
    currentGroupPage: currentGroupPage,
    paginationStores: paginationStores,
    isDetailedStock: isDetailedStock,
    infiniteScroll: infiniteScroll,
    forceAllStores: forceAllStores,
    fromPage: fromPage
  })), !isMaxTablet && /*#__PURE__*/React.createElement(GoogleMapContainer, {
    isMarkerShown: true,
    stores: infiniteScroll ? storesByStock : currentStores,
    setSelectedStore: setSelectedStore,
    openInfoWindow: openInfoWindow,
    setOpenInfoWindow: setOpenInfoWindow,
    searchedLocation: triggerSearchState.searchedLocation
  })));
  if (isPage) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes.page
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.pageBreadcrumbs
    }, /*#__PURE__*/React.createElement(BBLink, {
      to: '/'
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: 'global.home',
      defaultMessage: 'Home'
    }))), /*#__PURE__*/React.createElement("span", null, "/"), /*#__PURE__*/React.createElement("span", {
      className: classes.currentBreadcrumb
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: 'global.storeLocatorTitle',
      defaultMessage: 'Store Locator'
    }))), /*#__PURE__*/React.createElement("h1", {
      className: classes.pageTitle
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: 'global.storeLocatorTitle',
      defaultMessage: 'Store Locator'
    })), storeLocatorRender);
  }
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement("div", {
    className: classes.storeLocatorModalOverlay
  }, storeLocatorRender));
};
export default memo(mapEnvironment(StoreCheckoutLocatorModal));